import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { filter } from 'rxjs/operators';
import { ActionsService } from '../../services/actions.service';
import { Action } from '../../models/action/action.model';
import { Notification } from '../../models/notification/notification.model';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-notifications',
    standalone: true,
    imports: [MatProgressSpinner],
    templateUrl: './notifications.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./notifications.scss']
})
export class NotificationsComponent implements OnInit {
    notifications: Notification[] = [];

    constructor(private actionsService: ActionsService) {
    }

    ngOnInit() {
        
        this.actionsService.currentAction$
            .pipe(
                filter((action): action is Action => {
                    return !!action && !!action.type;
                })
            )
            .subscribe((action: Action) => {                
                let id = Math.random().toString(36).substr(2, 9);

                if (action.status === 'updated') {
                    this.notifications = this.notifications.filter(
                        (n: Notification) => n.action.status !== 'success'
                    );
                }

                this.notifications.push({
                    id: id,
                    action: action,
                    timeout: setTimeout(() => {
                        this.notifications = this.notifications.filter(
                            (notification: Notification) => notification.id !== id
                        );
                    }, 4000),
                });
            });
    }

    dismiss(id: string) {
        const notification = this.notifications.find((element) => element.id === id);
        if (notification) {
            clearTimeout(notification.timeout);
            this.notifications = this.notifications.filter(
                (notification: Notification) => notification.id !== id
            );
        }
    }
}